import { GetOneCompanyInDto, GetOneCompanyOutDto } from '../../../types/company.dto'

export const GET_ONE_COMPANY = 'GET_ONE_COMPANY'
export const GET_ONE_COMPANY_BY_SLUG = 'GET_ONE_COMPANY_BY_SLUG'
export const GET_ONE_COMPANY_SUCCESS = 'GET_ONE_COMPANY_SUCCESS'
export const GET_ONE_COMPANY_ERROR = 'GET_ONE_COMPANY_ERROR'
export const RESET_GET_ONE_COMPANY = 'RESET_GET_ONE_COMPANY'

export interface GetOneCompany {
  type: typeof GET_ONE_COMPANY | typeof GET_ONE_COMPANY_BY_SLUG
  payload: GetOneCompanyOutDto
}

export interface GetOneCompanySuccess {
  type: typeof GET_ONE_COMPANY_SUCCESS
  payload: GetOneCompanyInDto
}

export interface GetOneCompanyError {
  type: typeof GET_ONE_COMPANY_ERROR
  payload: string | boolean
}

export interface ResetGetOneCompany {
  type: typeof RESET_GET_ONE_COMPANY
  payload: null
}

export interface State {
  data: GetOneCompanyInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneCompany | GetOneCompanySuccess | GetOneCompanyError | ResetGetOneCompany
